import React, { useEffect } from 'react'

const Contact = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <>
      <div className="container">
        <div className="row">

          <div className="col-lg-7 d-flex justify-content-center">
            <div className="resort-content">
              <div className="resort-text">
                <div className="d-flex flex-wrap align-items-center mt-5">
                  <div className='col-sm-5 contact-us'>
                    <img src="/assets_web/img/about-us/about-us-icons.png" alt="HFHU-icons" />
                  </div>
                  <div className="col-sm-7">
                    <p className='text-font text-center'>
                      For the first time in Dhule City, Alhamdulillah, we bring you this life-changing offer. Be part of the HarmainFalahHajjUmrah  Campaign and see your Duas come true, Insha'Allah.
                    </p>
                  </div>
                </div>

                <div className="trip-route font-22">
                  <ul className='ps-0'>
                    <li className='yellow w-100'>
                      Act Now and Don't Let Costs Stand <br /> in Your Way!
                    </li>
                    <li className='green w-100'>
                      Insha'Allah, your spiritual journey is <br /> just a step away.
                    </li>
                  </ul>
                </div>

                <div className='contact'>
                  <h6 className="clrblu">
                    <b>Contact Us Today : </b>
                  </h6>
                  <p className='text-font mb-0'>
                    <i class='bx bxs-phone-call' /> +91 8055118236
                  </p>
                  <p className='text-font mb-0'>
                    <i class='bx bxs-envelope' /> hfhuvisionpvtltd@gmail.com
                  </p>
                  <p className='text-font'>
                    <i class='bx bx-current-location' /> Shope No. 3, Beside ENERGYM, Firdous Nagar Dhule.
                  </p>
                  <p className='text-font'>
                    Jazak Allah Khair for considering us and joining the many Muslims who are making their Hajj & Umrah dreams come true. This is your chance to embark on the most blessed journey with unmatched discounts, benefits, and lucky draws, Insha'Allah!
                  </p>
                  <h6 className='clrblu'>
                    Date and Location of Event: <br />Sunday, 04 May 2025. <br />Vadjai Road, Near New Muslim
                    Qabrastan , Dhule 424001
                  </h6>
                </div>

                {/* <div className="trip-route font-22">
                  <ul>
                    <li className='green text-start w-100'>
                      supported by: &nbsp; Team Delight My Trip<br />
                      Organized by: &nbsp; A Hafiz <br />
                      Campaign: &nbsp; Har Fard Hajj Umrah <br />
                    </li>
                    <li className='yellow w-100'>
                      <span>Thank You!</span> <br /> For your support
                    </li>
                  </ul>
                </div> */}

                <div className="trip-route font-22">
                  <ul className='ps-0'>
                    <li className='green text-start w-100'>
                      {/* <span>supported by: &nbsp;</span>Team Delight My Trip<br />
                      <span>Organized by: &nbsp;</span>A Hafiz <br />
                      <span>Campaign: &nbsp;</span>Har Fard Hajj Umrah <br /> */}
                      supported by: &nbsp; Team Delight My Trip<br />
                      Organized by: &nbsp; A Hafiz <br />
                      Campaign: &nbsp; Harmain Falah Hajj Umrah <br />
                    </li>
                    <li className='yellow w-100'>
                      <span>Thank You!</span> <br /> For your support
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className='mdn_img contact-img d-none d-lg-block'>
              <img src="/assets_web/img/about-us/mosque.png" alt="mosque (image)" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact
